import { get } from "lodash";

export default stats => get(stats, "stats", {});
